// @spec BCP-STR-054
import { createFileRoute } from '@tanstack/react-router';

import { GapAnalysisReport } from '@/features/bcp/components/GapAnalysisReport';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/reports/gap-analysis')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.gapAnalysisReport'),
  }),
  component: GapAnalysisReportPage,
});

function GapAnalysisReportPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <GapAnalysisReport />
      </div>
    </div>
  );
}
